// import { ClassNames } from '@emotion/react';
// import { Button, Paper, Stack, Typography, styled } from '@mui/material';
// import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react';
// import classes from './Sidebar.module.css'
// import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
// import { ToggleContext, UserContext } from '../../hooks/UserContext';
// import { DUAL_ACCOUNT_REPORT, PART_D_PREDETERMINATION_REPORT, INBOUND_CORR_WB_REPORT, PART_D_DUPLICATE_REPORT, PART_D_IE_REPORT, PART_D_MULTIPLE_REPORT, RESOLVED_COMPLETED_REPORT, TRANSITIONAL_OVERRIDE_REPORT, UHCEI_DUPLICATE_DENIAL_REPORT, XCPINDEXING_REPORT } from '../../constants/reportNames';
// import { ADMIN,TECHNICIAN } from '../../constants/userConstants';
// import { useGetWorkbenchData, useGetWorkbenchDataForSidebar } from '../../hooks/useGetWorkbenchData';
// import { getEmail, getMSID, getName } from '../../authfile';
// import dayjs from 'dayjs';

// const Sidebar = (props) => {
//     const navigate = useNavigate();
//     const {pathname} = useLocation();
//     const {userRole} = useContext(UserContext);
//     const isFromUnauthorize = props.unauthorize;
//     const [startDate, setStartDate] = useState(dayjs().subtract(7, 'day'));
//     const [endDate, setEndDate] = useState(dayjs(new Date()));
//     const formattedDateStart = startDate ? formatDate(startDate) : '';
//     const formattedDateEnd = startDate ? formatDate(endDate) : '';
//     const {toggleForTech} = useContext(ToggleContext);
//     const [reportMap, setReportMap] = useState(new Map(props?.technicianCountData?.map((item, index) => {
//         return (
//             [item?.ReportName, item?.CountOfCases ?? 0]
//         )
//     })));
//     const checkColorForReport = () => {
//         if(userRole == ADMIN){
//             if(pathname == "/workbench")
//                 return true;
//         }
//         if(userRole == TECHNICIAN){
//             if(pathname == "/" || pathname == "/workbench")
//                 return true;
//         }
//         return false;
//     }

//     let { report: reportStateVariable } = useLocation().state || {report : null};
//     if(reportStateVariable == null || reportStateVariable == undefined ){
//         if(checkColorForReport() == true){
//             reportStateVariable = DUAL_ACCOUNT_REPORT;
//         }
//     }


//     useEffect(() => {
//         const reportMapVar = new Map(props?.technicianCountData?.map((item, index) => {

//             return (
//                 [item?.ReportName, item?.CountOfCases ?? 0]
//             )
//         }))
//         setReportMap(new Map(props?.technicianCountData?.map((item, index) => {

//             return (
//                 [item?.ReportName, item?.CountOfCases ?? 0]
//             )
//         })));

//     }, [props?.technicianCountData])


//     const selectedReports = [
//         [DUAL_ACCOUNT_REPORT, INBOUND_CORR_WB_REPORT, PART_D_DUPLICATE_REPORT, PART_D_IE_REPORT, PART_D_MULTIPLE_REPORT, PART_D_PREDETERMINATION_REPORT, RESOLVED_COMPLETED_REPORT, TRANSITIONAL_OVERRIDE_REPORT, UHCEI_DUPLICATE_DENIAL_REPORT, XCPINDEXING_REPORT]
//     ];

//     const handleWorkbenchNavigation = (report) => {
//         navigate('/workbench', {
//             state: {
//                 report: report
//             }
//         })
//     }

//     const {
//         data,
//         isError: isLoadingWorkbenchDataError,
//         isFetching: isFetchingWorkbenchData,
//         isLoading: isLoadingWorkbenchData,
//         refetch: refetchWorkbenchData
//       } = useGetWorkbenchDataForSidebar({
//         "msid": getMSID(),
//         "name": getName(),
//         "role": toggleForTech == true ? TECHNICIAN : userRole,
//         "email": getEmail(),
//         fromDate: formattedDateStart,
//         toDate: formattedDateEnd,
//         "report": reportStateVariable
//     });

//     function formatDate(date){
//         const d = new Date(date);
//         let month = '' + (d.getMonth() + 1);
//         let day = '' + d.getDate();
//         let year = d.getFullYear();
//         if (month.length < 2) month = '0' + month;
//         if (day.length < 2) day = '0' + day;
//         return String([month, day, year].join('-'));
//     }

//     console.log("The data in sidebar is", data);

//     return (
//         <div className={classes.sidebar}>
//             <div className={classes.sidebarHeading}>
//                 <Typography component="p" sx={{ color: '#ff4400', fontSize: '2.5rem' }}>Optum</Typography>
//                 <Typography component="p">Retro Quality Audit</Typography>
//             </div>
//             {
//                 isFromUnauthorize != true &&

//                 <div className={classes.sideBarLinks}>
//                     <Button variant='contained' fullWidth disableElevation>Reports</Button>
//                     <div className={classes.sideBarReportLinks}>
//                         {
//                         data !== null && data !== undefined ? 
//                         data?.['TechnicianCountData'].map((eachReport, index) => (
//                               <Typography component="p" key={index} sx={{textAlign: 'left', fontSize: '0.8rem', cursor: 'pointer', my: 1,p:1, color: reportStateVariable == eachReport?.['ReportName'] ? '#ff612b' : '#002277' }} onClick={() => handleWorkbenchNavigation(eachReport?.['ReportName'])}>{eachReport?.['ReportName']}{ `(${eachReport?.['CountOfCases'] ? eachReport['CountOfCases'] : '0'})` }</Typography> 

//                         )) : 

//                         selectedReports[0].map((report, index) => (
//                             <Typography component="p" key={index} sx={{textAlign: 'left', fontSize: '0.8rem', cursor: 'pointer', my: 1,p:1, color: reportStateVariable == report ? '#ff612b' : '#002277' }} onClick={() => handleWorkbenchNavigation(report)}>{report}</Typography> 
//                         ))

//                         }
//                     </div>
//                 </div>
//             }
//         </div>
//     );
// };

// export default Sidebar;

import { ClassNames } from '@emotion/react';
import { Button, Paper, Stack, Typography, styled } from '@mui/material';
import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import classes from './Sidebar.module.css'
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { UserContext } from '../../hooks/UserContext';
import { ADMIN, TECHNICIAN } from '../../constants/routeConstants';
import { DUAL_ACCOUNT_REPORT, PART_D_PREDETERMINATION_REPORT, INBOUND_CORR_WB_REPORT, PART_D_DUPLICATE_REPORT, PART_D_IE_REPORT, PART_D_MULTIPLE_REPORT, RESOLVED_COMPLETED_REPORT, TRANSITIONAL_OVERRIDE_REPORT, UHCEI_DUPLICATE_DENIAL_REPORT, XCPINDEXING_REPORT } from '../../constants/reportNames';

const Sidebar = (props) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { userRole } = useContext(UserContext);
    const isFromUnauthorize = props.unauthorize;

    const [reportMap, setReportMap] = useState(new Map(props?.technicianCountData?.map((item, index) => {

        return (
            [item?.ReportName, item?.CountOfCases ?? 0]
        )
    })));


    useEffect(() => {
        const reportMapVar = new Map(props?.technicianCountData?.map((item, index) => {

            return (
                [item?.ReportName, item?.CountOfCases ?? 0]
            )
        }))
        setReportMap(new Map(props?.technicianCountData?.map((item, index) => {

            return (
                [item?.ReportName, item?.CountOfCases ?? 0]
            )
        })));

    }, [props?.technicianCountData])

    const checkColorForReport = () => {
        if (userRole == ADMIN) {
            if (pathname == "/workbench")
                return true;
        }
        if (userRole == TECHNICIAN) {
            if (pathname == "/" || pathname == "/workbench")
                return true;
        }
        return false;
    }
     

    let { report: reportStateVariable } = useLocation().state || { report: null };
    if (reportStateVariable == null || reportStateVariable == undefined) {
        if (checkColorForReport() == true) {
            reportStateVariable = DUAL_ACCOUNT_REPORT;
        }
    }
    const selectedReports = [
        [DUAL_ACCOUNT_REPORT, INBOUND_CORR_WB_REPORT, PART_D_DUPLICATE_REPORT, PART_D_IE_REPORT, PART_D_MULTIPLE_REPORT, RESOLVED_COMPLETED_REPORT, TRANSITIONAL_OVERRIDE_REPORT, UHCEI_DUPLICATE_DENIAL_REPORT, XCPINDEXING_REPORT, PART_D_PREDETERMINATION_REPORT]
        // ['Part D PreDetermination', 'Resolved-Dismissed', 'Transitional Override'],
        // ['UHCEI Duplicate Denial', 'xCP Indexing Report']
    ];
    const getRandomReport = () => {
        const randomIndex = Math.floor(Math.random() * selectedReports.length);
        return selectedReports[randomIndex];
    };
    const handleWorkbenchNavigation = (report) => {
        navigate('/workbench', {
            state: {
                report: report
            }
        })
    }

    return (
        <div className={classes.sidebar}>
            <div className={classes.sidebarHeading}>
                <Typography component="p" sx={{ color: '#ff4400', fontSize: '2.5rem' }}>Optum</Typography>
                <Typography component="p">Retro Quality Audit</Typography>
            </div>
            {
                isFromUnauthorize != true &&

                <div className={classes.sideBarLinks}>
                    <Button variant='contained' fullWidth disableElevation>Reports</Button>
                    <div className={classes.sideBarReportLinks}>
                        {selectedReports[0].map((report, index) => (
                            <Typography component="p" key={index} sx={{ textAlign: 'left', fontSize: '0.8rem', cursor: 'pointer', my: 1, p: 1, color: reportStateVariable == report ? '#ff612b' : '#002277' }} onClick={() => handleWorkbenchNavigation(report)}>{report}{props.isLoading || reportMap.get(report) === undefined ? "" : `(${reportMap.get(report)})`}</Typography>

                        ))}
                    </div>
                </div>
            }
        </div>
    );
};

export default Sidebar;